import { Layout } from "antd";
import styled from "styled-components";

const { Footer } = Layout;

export const CustomFooter = styled(Footer)`
  align-items: center;
  background-color: var(--white);
  color: var(--font-color);
  font-family: "Noto Sans Thai";
  padding: 118px 118px 0 118px;

  @media screen and (max-width: 414px) {
    padding: 50px 50px 0 50px;
  }

  @media screen and (max-width: 820px) {
    padding: 50px 50px 0 50px;
  }

  @media screen and (max-width: 912px) {
    padding: 50px 50px 0 50px;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    padding: 50px 50px 0 50px;
  }
`;

export const CardFooter = styled.div`
  width: 100%;
  padding: 120px 140px;
  background-color: var(--third);
  border-radius: 20px 20px 0px 0px;

  @media screen and (max-width: 414px) {
    padding: 40px;
  }

  @media screen and (max-width: 820px) {
    padding: 40px;
  }

  @media screen and (max-width: 912px) {
    padding: 40px;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    padding: 50px;
  }

  .left {
    padding-top: 110px;
    padding-left: 110px;
  }

  .img {
    cursor: pointer;
    svg {
      max-width: 100%;
      height: auto;
    }
  }

  @media screen and (max-width: 540px) {
    .ant-col-8 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-col-16 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .logo {
      svg {
        width: 98%;
        height: auto;
      }
    }

    .row-img-phone .ant-col-24 {
      display: flex !important;
      justify-content: center !important;
    }

    .left {
      padding-top: 35px;
      padding-left: 0;
    }
  }

  @media screen and (max-width: 820px) {
    .phone {
      max-width: 140px !important;
      height: auto;
    }
    .left {
      padding-top: 35px;
      padding-left: 35px;
    }
  }

  @media screen and (max-width: 912px) {
    .phone {
      max-width: 140px !important;
      height: auto;
    }
    .left {
      padding-top: 35px;
      padding-left: 35px;
    }
  }

  @media screen and (max-width: 1440px) {
    .phone {
      max-width: 180px;
      height: auto;
    }
    .left {
      padding-top: 35px;
      padding-left: 35px;
    }
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    .phone {
      max-width: 140px !important;
      height: auto;
    }
    .left {
      padding-top: 35px;
      padding-left: 35px;
    }
  }
`;

export const TitleContact = styled.p`
  font-size: clamp(35px, 2vw, 80px);
  line-height: 50px;
  margin: 40px 0;

  @media screen and (max-width: 820px) {
    line-height: 30px;
    margin: 15px 0;
  }

  @media screen and (max-width: 912px) {
    line-height: 40px;
    margin: 25px 0;
  }

  @media screen and (max-width: 1440px) {
    line-height: 40px;
    margin: 25px 0;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    line-height: 40px;
    margin: 25px 0;
  }
`;

export const TextContact = styled.p`
  font-size: ${(props) => (props.size ? `${props.size}px` : "18px")};
  line-height: ${(props) => (props.size ? `28px` : "22px")};

  @media screen and (max-width: 414px) {
    font-size: 16px;
  }
`;
